
import containerSizes from './EoContainer.scss?module'

export default {
  name: 'EoContainer',
  props: {
    /**
     * Style: max width (2, 4, 6, 8, 10, 12, fullwidth)
     */
    size: {
      type: [String, Number],
      default: 12,
      validator: (value) => {
        return value === 'fullwidth' || (2 <= Number(value) && Number(value) <= 12 && (Number(value) % 2 !== 1)) || value?.includes(':')
      },
    },
    /**
     * Style: left and right padding (only when not reached max width)
     */
    paddedX: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: top and bottom padding
     */
    paddedY: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: background color of the container
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Style: color of the text and icons
     */
    textColor: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      width: 0,
      containedWidth: 0,
      offset: 0,
    }
  },
  computed: {
    classes () {
      return {
        'eo-container': true,
        'padded-x': this.paddedX,
        'padded-y': this.paddedY,
        ['color--' + this.color]: this.color,
        ['text--' + this.textColor]: this.textColor,
      }
    },
    styles () {
      return {
        '--width-xs': this.getMaxWidth('xs'),
        '--width-sm': this.getMaxWidth('sm'),
        '--width-md': this.getMaxWidth('md'),
        '--width-lg': this.getMaxWidth('lg'),
        '--width-xl': this.getMaxWidth('xl'),
      }
    },
  },
  mounted () {
    this.width = this.$refs.parent?.offsetWidth
    this.containedWidth = this.$refs.wrapper?.offsetWidth
    this.offset = Number((this.width - this.containedWidth) / 2)
  },
  methods: {
    getMaxWidth (breakpoint) {
      if (!this.size) return
      return containerSizes[`container-width-${this.$viewport.switch(this.size, breakpoint)}`]
    },
    async onResize (info) {
      this.width = info.inlineSize
      this.containedWidth = this.$refs.wrapper?.offsetWidth
      this.offset = Number((this.width - this.containedWidth) / 2)
    },
  },
}
